<template>
  <div class="layout-content-page">
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.layout-content-page {
  padding: 3em 0;
  .content {
    width: 750px;
    max-width: 100%;
    position: relative;
    margin: 0 auto;
  }
  p {
    font-size: 18px;
    line-height: 150%;
    margin: 1em 0;
  }
  a {
    border-bottom: 1px dashed;
  }
  .ui-breadcrumbs {
    position: relative;
    text-align: center;
    margin-bottom: 1em;
  }
  .ui-breadcrumbs a {
    border: none;
  }
  h1 {
    margin-bottom: 1em;
  }
}

@media screen and (max-width: 767px) {
  .layout-content-page {
    .content {
      padding: 0 var(--gap);
    }
  }
}
</style>
